import React, { FC, useEffect, useState } from 'react';
import { RootState } from 'redux/store';
import { useSelector } from 'react-redux';

import ContentBlock from 'components/ContentBlock/Index';
import { ISkillsTab } from 'core/interface/skills';
import { IMe } from 'core/interface/me';
import { SkillService } from 'services/skills/skillService';
import Popup from 'components/shared/Popups/Popup/Index';
import { LanguageService } from 'services/language';
import SkillsBlock from 'components/shared/SkillsBlock/Index';

import './Index.scss';
import GeneralSkillsPopup from 'components/shared/Popups/General-skills/Index';

const SkillsTab: FC<ISkillsTab> = ({
  t,
  candidate_id,
  fromGuest
}): JSX.Element => {
  const me = useSelector((state: IMe) => state.user).user;
  const [showAddOrEditHardSkill, setShowAddOrEditHardSkill] =
    useState<boolean>(false);
  const [showAddOrEditSoftSkill, setShowAddOrEditSoftSkill] =
    useState<boolean>(false);

  const [resend, setResend] = useState<boolean>(false);
  const { skills } = useSelector((state: RootState) => state.skills);
  const { candidates } = useSelector((state: RootState) => state.candidates);

  useEffect(() => {
    getSkills();
  }, []);

  useEffect(() => {
    if (resend) {
      getSkills();
      handleClose();
      setResend(false);
    }
  }, [resend]);

  useEffect(() => {
    getLanguages();
  }, [me]);

  const handleClose = (): void => {
    setShowAddOrEditHardSkill(false);
    setShowAddOrEditSoftSkill(false);
    return;
  };

  const getSkills = async (): Promise<void> => {
    if (candidate_id) {
      await SkillService.getITSkills(candidate_id);
    }
  };

  const getLanguages = async (): Promise<void> => {
    await LanguageService.getCandidateLanguage(me.candidate_id);
  };

  return (
    <div className="skills-block-side">
      <ContentBlock
        className="skill-block"
        title={t('Hard Skills')}
        noData={candidates?.hard_skills === 0}
        onActionClick={() => setShowAddOrEditHardSkill(true)}
        showButton={fromGuest ? false : true}
      >
        <div className="skill-block-content">
          {candidates?.hard_skills?.map((skill: any) => (
            <div key={skill.id} className="blocks">
              <SkillsBlock title={skill} />
            </div>
          ))}
        </div>
      </ContentBlock>
      <ContentBlock
        className="skill-block soft-skills"
        title={t('Soft Skills')}
        noData={candidates?.soft_skills === 0}
        onActionClick={() => setShowAddOrEditSoftSkill(true)}
        showButton={fromGuest ? false : true}
      >
        <div className="skill-block-content">
          {candidates?.soft_skills?.map((skill: any) => (
            <div key={skill.id} className="blocks">
              <SkillsBlock title={skill} />
            </div>
          ))}
        </div>
      </ContentBlock>

      {(showAddOrEditHardSkill || showAddOrEditSoftSkill) && (
        <Popup
          title={showAddOrEditHardSkill ? t('Hard Skills') : t('Soft Skills')}
          className="expertise"
          onClose={handleClose}
        >
          <GeneralSkillsPopup
            handleClose={handleClose}
            t={t}
            candidateId={candidate_id}
            skillCategory={
              showAddOrEditHardSkill ? 'hard_skills' : 'soft_skills'
            }
            existingHardSkills={candidates?.hard_skills || []}
            existingSoftSkills={candidates?.soft_skills || []}
          />
        </Popup>
      )}
    </div>
  );
};

export default SkillsTab;
